import {
  DATA_CONNECTOR_GET_COLLECTIONS_FOR_DIRECTUS_BEGIN,
  DATA_CONNECTOR_GET_COLLECTIONS_FOR_DIRECTUS_SUCCESS,
  DATA_CONNECTOR_GET_COLLECTIONS_FOR_DIRECTUS_FAILURE,
  DATA_CONNECTOR_GET_COLLECTIONS_FOR_DIRECTUS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';
export function getCollectionsForDirectus(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_GET_COLLECTIONS_FOR_DIRECTUS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/directus/get-collection`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_GET_COLLECTIONS_FOR_DIRECTUS_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_GET_COLLECTIONS_FOR_DIRECTUS_FAILURE,
            data: { error: err },
          });
          toast.error(`Failed: Please Check your Credentials !`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetCollectionsForDirectusError() {
  return {
    type: DATA_CONNECTOR_GET_COLLECTIONS_FOR_DIRECTUS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_GET_COLLECTIONS_FOR_DIRECTUS_BEGIN:
      return {
        ...state,
        getCollectionsForDirectusPending: true,
        getCollectionsForDirectusError: null,
      };

    case DATA_CONNECTOR_GET_COLLECTIONS_FOR_DIRECTUS_SUCCESS:
      return {
        ...state,
        getCollectionsForDirectusPending: false,
        getCollectionsForDirectusError: null,
        collectionByDirectus: action.data,
      };

    case DATA_CONNECTOR_GET_COLLECTIONS_FOR_DIRECTUS_FAILURE:
      return {
        ...state,
        getCollectionsForDirectusPending: false,
        getCollectionsForDirectusError: action.data.error,
      };

    case DATA_CONNECTOR_GET_COLLECTIONS_FOR_DIRECTUS_DISMISS_ERROR:
      return {
        ...state,
        getCollectionsForDirectusError: null,
      };

    default:
      return state;
  }
}
